export enum CreateAccountRequestType {
	SUB = 1,
	VIRTUAL = 2,
}

export enum CreateAccountRequestStatus {
	PENDING = 1,
	CREATED = 2,
}
